import PredictiveSearch from "@/lib/predictive-search";

import { add, listen, qs, remove, toggle } from "@fluorescent/dom";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { createFocusTrap } from "focus-trap";

const classes = {
  active: "active",
  visible: "visible",
};

export default function (node) {
  const overlay = qs("[data-overlay]", node);
  const form = qs("form", node);
  const input = qs("[data-input]", node);
  const clear = qs("[data-clear]", node);
  const resultsContainer = qs("[data-results]", node);
  const focusTrap = createFocusTrap(node);

  // This gets replaced with a focus trapping util on `open` however
  // this should prevent any errors if the quick search is destroyed
  // when it wasn't open
  let lockbox = () => {};

  const overlayClick = listen(overlay, "click", close);
  const clearClick = listen(clear, "click", reset);
  const keyDown = listen(node, "keydown", checkEscape);
  const inputChange = listen(input, "input", handleInput);

  const predictiveSearch = new PredictiveSearch(resultsContainer);

  function handleInput(e) {
    let populated = e.target.value !== "";
    if (e.target.value === "") remove(resultsContainer, classes.visible);
    toggle(clear, classes.visible, populated);
    toggle(resultsContainer, classes.visible, populated);
    clear.setAttribute("tabindex", populated ? 0 : -1);

    predictiveSearch.getSearchResults(e.target.value);
  }

  function checkEscape({ keyCode }) {
    if (keyCode === 27) close();
  }

  // Clear contents of the search input and hide results container
  function reset(e) {
    e.preventDefault();
    input.value = "";
    remove([resultsContainer, clear], classes.visible);

    input.focus();
  }

  function open() {
    add(node, classes.active);
    setTimeout(() => {
      focusTrap.activate();
      disableBodyScroll(node, { reserveScrollBarGap: true });
      add(node, classes.visible);
    }, 50);
  }

  function close() {
    remove(node, classes.visible);
    setTimeout(() => {
      remove(node, classes.active);
      enableBodyScroll(node);
      lockbox();
      focusTrap.deactivate();
    }, 350);
  }

  function destroy() {
    close();

    overlayClick();
    clearClick();
    keyDown();
    inputChange();
  }

  return { open, close, destroy };
}
